import * as React from "react"
import { X } from "lucide-react"

/** A full-width notice at the top of a page. Pass `onDismiss` to let people close it. */
export function Banner({
  children,
  onDismiss,
  dismissLabel = "Dismiss",
}: {
  children: React.ReactNode
  onDismiss?: () => void
  dismissLabel?: string
}) {
  return (
    <div className="callout callout-accent mb-6 flex items-start gap-3 py-3">
      <p className="min-w-0 flex-1 text-sm/6 text-ink-body">{children}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="-m-1 inline-flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-md text-ink-muted hover:text-ink-display focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
          aria-label={dismissLabel}
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
